module.exports = __webpack_public_path__ + "static/z_perfect-c641d8050e56439e6029e4940dfd615a.jpg";